import { Model } from "vue-mc";

export class Status extends Model {
  defaults() {
    return {
      clave: null
      , descripcion: ""
      , canales: ""
      , substatus: ""
      , agregador: true
      , showinapp: false
      , merchandising: false
      , exclusiones: false
      , status: true
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , descripcion: (descripcion) => descripcion
      , canales: (canales) => canales
      , substatus: (substatus) => substatus
      , agregador: (agregador) => agregador
      , showinapp: (showinapp) => showinapp
      , merchandising: (merchandising) => merchandising
      , status: (status) => status
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/operativos/status.js